export const IdentificationTypes = {
  driverLicense: 'Driver License',
  greenCard: 'Green Card',
  passport: 'Passport',
  stateId: 'State Identification',
  other: 'Other (Photo)',
};
